import { _ } from "$json";
import { converter } from "$md-converter";
import { escapeHTML } from "$json/lib/escape";
// > Author: Niels Giesen
// > Copyright 2013, 2017, 2019 Berkeley Bridge

// ## Introduction

// Supplies sane defaults for our forms:

// - inline info (with commonmark markdown)
// - grid-layout for forms

// Supplants stuff such as:

// - info-inline
// - info-relative
// - questionlabelgroup

// Don'ts when using this plugin:

// For now: `conf.a11y.optionfieldsets=true` -- this does not render well on Chrome and Edge.

/* questionlabelgroup-wrapping-input:
 *
 * Next-generation questionlabelgroup plugin.
 *
 * It will eventually probably replace the default implementation.
 *
 * Author: Niels Giesen
 * Copyright 2013, 2017 Berkeley Bridge
 *
 */
import { bb, gt } from "$json";
import Mustache from "mustache";
(function ($, document) {
  // ### Placement

  // The plugin groups labels and inputs together, and adds hints as to the prefered placement.

  // Our configuration options resides here
  var conf = bb.propFinder(bb.conf, "arbitrary.form-group");

  // Default placement mapping

  var layoutmap = {
    edit: "aside",
    numedit: "aside",
    checkbox: "inline",
    datetimepicker: "aside",
    combobox: "aside",
    freebox: "aside",
    linklabel: "below",
    listlabel: "below",
    memo: "below",
    checkmultilist: "below",
    multilist: "below",
    grid: "below",
    listbox: "aside",
    radio: "below"
  };

  // Configuration option `arbitrary.form-group.layoutmap` may override some or all of these.
  $.extend(layoutmap, conf("layoutmap", {}));

  // Example
  //
  //     "layoutmap": {
  //       "checkbox": "inline",
  //       "radio": "below",
  //       "memo": "aside"
  //     } ,

  // ### Grouping

  // By default, all 'inline' (edit, numedit, datetimepicker and
  // combobox) controltypes are grouped with label-less ('orphaned')
  // siblings that are also `edit`s.

  // Configuration option `arbitrary.form-group.combinables` allows grouping more types, or less.

  var combinables = conf("combinables", [
    "edit",
    "numedit",
    "datetimepicker",
    "combobox",
    "freebox"
  ]);

  // Example
  //
  //      "combinables": ["edit", "numedit"]

  // Create a selector that matches either something whose data-type
  // is in `types`, or who wraps a data-type in `types`
  function createMaybeWrappedTypeSelector(types) {
    return types.reduce(function (mem, type) {
      return (
        mem +
        (mem ? ", " : "") +
        '[data-type="' +
        type +
        '"], [data-wraps-type="' +
        type +
        '"]'
      );
    }, "");
  }

  // Selector for optionally wrapped combinables
  var combinableSelector = createMaybeWrappedTypeSelector(combinables);

  // Unbind default "bb:questionlabelgroup" handler
  $(document).off("bb:questionlabelgroup");

  const propertiesForWrapper = function (elt) {
    if (elt.className) {
      let className = elt.className.match(/\bbbm-[a-z0-9-]+\b/);
      if (className) {
        className = className[0].replace(/\bbbm-/, "bb-g-");
      }
      const type = elt.getAttribute("data-type");
      const datatype = elt.getAttribute("data-datatype");
      return { className, type, datatype };
    }
    return { className: "" };
  };

  // Override the default questionlabelgroup function
  bb.questionlabelgroup = function () {
    var $group = $(".group:not(.p-form-group__ed)");
    $group.addClass("p-form-group__ed");
    $(">.bb-label", $group).each(function () {
      var $this = $(this),
        control = $this.data("control"),
        $inputs = $this.prev("[type=checkbox]"),
        isCheckBox = $inputs.is("[type=checkbox]"),
        headtype,
        types = [],
        datatypes = [],
        doFieldset =
          bb.conf.a11y.optionfieldsets && control.controltype === "legend",
        $fields,
        $inner,
        $outer;

      if (!isCheckBox) {
        var $next = $this.next();
        $inputs = $inputs.add($next);
        if ($next.is(combinableSelector)) {
          while ((($next = $next.next()), $next.is(combinableSelector))) {
            $inputs = $inputs.add($next);
          }
        }
      }

      if ($inputs.length === 0 && $this.next().is('[data-type="linklabel"]')) {
        $inputs = $this.next();
      }

      if ($inputs.length > 0) {
        headtype = $inputs.data("type");

        if (!isCheckBox) {
          $inputs.wrapAll(
            '<div class="p-form-group--fields"' +
              ' data-p-form-group--fields__nr="' +
              $inputs.length +
              '"></div>'
          );
          $fields = $inputs.parent("div");
          if (
            $next &&
            $next.data("control") &&
            $next.data("control").controltype === "grid"
          ) {
            $fields.append($fields.next("button.bb-record-add"));
          }
        } else {
          $inputs.addClass("p-form-group--fields");
          $fields = $inputs;
        }

        $inner = $this.add($fields);

        $outer = $(document.createElement(doFieldset ? "fieldset" : "div"));
        var layout = $inputs.data("control")._layout || layoutmap[headtype];
        $outer.attr("data-p-form-group-layout-type", layout);

        if ($inner.length > 1) {
          var classNames = [
            "bb-questionlabelgroup",
            "p-form-group",
            "p-form-group-mixed",
            "bb-fields-" + $inner.length
          ];

          /* Offspring and self (checkbox) */
          $.each(
            $fields
              .find("*")
              .addBack()
              .filter('[data-type]:not([data-type="grid"] *)'),
            function () {
              const { className, type, datatype } = propertiesForWrapper(this);
              if (className) classNames.push(className);
              if (types.indexOf(type) === -1) {
                types.push(type);
              }
              if (datatypes.indexOf(datatype) === -1) {
                datatypes.push(datatype);
              }
            }
          );

          $fields.add($outer).attr("data-wraps-types", types.join(" "));
          $fields.add($outer).attr("data-wraps-datatypes", datatypes.join(" "));

          // All tags of descendant inputs end up as className `.bb-child-tagged-` + tag on the form group.
          $.each($inputs, function (_, elt) {
            $.each($(elt).data("tags") || [], function (_, tag) {
              classNames.push("bb-child-tagged-" + tag);
            });
          });
        }

        $outer.addClass(classNames.join(" "));
        $inner.wrapAll($outer);
      }
      // CAN BE zero when there is a label to a linklabel, but that
      // linklabel has been rendered as bb-text instead. Is a model
      // error, but we should not allow this to cause an error for the
      // end-user.
    });
    $(">.bb-text", $group).each(function () {
      var $this = $(this),
        { className } = propertiesForWrapper(this);
      $this.wrap(
        `<div class="${className} p-form-group p-form-group-text"></div>`
      );
    });
    // Wrap orphaned widgets
    $(">[data-type]:not(legend)", $group).each(function () {
      const $this = $(this);
      const { className, type, datatype } = propertiesForWrapper(this);

      $this.wrap(
        `<div
          data-p-form-group-layout-type="below"
          class="bb-questionlabelgroup ${className} p-form-group p-form-group-orphaned"
          data-wraps-types="${type}"
          data-wraps-datatypes="${datatype}"
        >
          <div class="p-form-group--fields"></div>
        </div>`
      );
    });
  };

  // ### Information sources

  // Translation strings for info buttons
  var translations = {
    "more info about this question": {
      nl: "meer informatie over deze vraag",
      fr: "plus d'information sur cette question",
      de: "mehr Informazionen über diese Frage"
    },
    "close": {
      nl: "sluiten",
      fr: "fermer",
      de: "abschließen",
      ru: "всклучить"
    }
  };

  $(function () {
    gt.addTranslations(translations);
  });

  // Default placement of info button is at the end of the form.
  var buttonplacement;
  // Configuration option `arbitrary.form-group.info.buttonplacement` overrides this.
  buttonplacement = conf("info.buttonplacement", "beforeEnd");

  /**
   * @return unique integer
   */
  var genid = (function () {
    var id = 0;
    return function genid() {
      return id++;
    };
  })();

  // Toggle class `.p-form-group-with-errors` on the `.form-group` whenever an error
  // happens.
  $(document).on("bb:errorOn", ".p-form-group", function () {
    $(this).addClass("p-form-group-with-errors");
  });
  $(document).on("bb:errorOff", ".p-form-group", function () {
    $(this).removeClass("p-form-group-with-errors");
  });

  // Note that errors itself are shown inside the `.p-form-group--fields` block.

  $(function () {
    Mustache.tags = ["[[", "]]"];

    // **Important**: Include the info.mustache partial for information sources in your template.html
    //
    //     {{> plugins/form-group/info }}

    var tmpl = $("#p-form-group-info-template").html();

    if (typeof tmpl === "undefined") {
      console.warn("form-group.js: No template found");
      return;
    }

    $(document).on("bb:postHandleData", function (event, data) {
      if (data && data.informationsources) {
        var info = data.informationsources.filter(interesting);
        info = Object.values(Object.groupBy(info, src => src.groupguid));
        info.map(associateEltWithFirst);
        info.map(render);
      }
    });

    function prepareSource(source) {
      return $.extend({}, source, {
        content: source.isurl
          ? source.content
          : converter.makeHtml(escapeHTML(source.content)),
        description: source.description || (source.isurl ? source.content : "")
      });
    }

    function getFormGroup(node) {
      var klass;
      while (
        ((node = node.parentElement),
        (klass = node && node.getAttribute("class")),
        node && (!klass || klass.split(" ").indexOf("p-form-group") === -1))
      );
      return node;
    }

    function interesting(src) {
      return true || src.selected;
    }

    function associateEltWithFirst(srcs) {
      var src = srcs[0];
      var elts = document.querySelectorAll('[data-id="' + src.belongsto + '"]');
      if (elts) src.widgets = [...elts].map(elt => getFormGroup(elt) || elt);
    }

    function render(srcs) {
      var src = srcs[0],
        multiple = srcs.length > 1;
      if (!src.widgets) return;
      for (let widget of src.widgets) {
        let container = widget.nextElementSibling,
          infogroups,
          id,
          contents = Mustache.render(tmpl, {
            sources: srcs.map(function (src) {
              return prepareSource(src);
            }),
            multiple: multiple,
            proposedItemTag: multiple ? "li" : "div"
          });

        if (!container || container.className !== "p-form-group-info-block") {
          id = "p-form-group-info-" + genid();
          widget.insertAdjacentHTML(
            buttonplacement,
            '<button aria-pressed="false"' +
              ' aria-controls="' +
              id +
              '"' +
              ' tabindex="0" class="p-form-group-info-link">' +
              '<span class="a-offscreen">' +
              _("more info about this question") +
              "</span>" +
              "</button>\n"
          );
          const infoGroupDiv = document.createElement("div");
          infoGroupDiv.id = id;
          infoGroupDiv.setAttribute("aria-hidden", true);
          infoGroupDiv.setAttribute("role", "note");
          infoGroupDiv.setAttribute(
            "data-form-group-info-groups",
            src.groupguid
          );
          infoGroupDiv.classList.add("p-form-group-info-block");
          infoGroupDiv.style.display = "none";
          infoGroupDiv.insertAdjacentHTML(
            "beforeEnd",
            (multiple ? "<ul>" : "") +
              contents +
              (multiple ? "</ul>" : "") +
              "<button" +
              ' aria-pressed="false" aria-controls="' +
              id +
              '"' +
              ' class="p-form-group-info-close">' +
              _("close") +
              "</button>"
          );
          widget.insertAdjacentElement("afterEnd", infoGroupDiv);
        } else {
          infogroups = container.getAttribute("data-form-group-info-groups");
          if (infogroups.indexOf(src.groupguid) < -1) {
            container.children[0].insertAdjacentHTML("beforeEnd", contents);
            container.setAttribute(
              "data-form-group-info-groups",
              infogroups + src.groupguid
            );
          }
        }
      }
    }

    // Information sources are all rendered inline, after the form group they are attached to.

    // As they slide in or out, their open/close button(s) have the `.active` class.

    // This means you can style them pretty well according to their state as in the following example.

    // ```less
    // /* Custom link look and feel */
    // .p-form-group-info-link {
    //   background: darkgrey;
    //   color: #fff;
    //   border-radius: 50%;
    //   border: none;
    //   height: @p-form-group-info-button-inline-size;
    //   cursor: pointer;
    //   &:focus {
    //     box-shadow: @custom-box-shadow;
    //     outline: none;
    //   }
    //   // [aria-pressed="true"] could even have a different color - it means the thing is opened.
    //   &:hover, &.active, &[aria-pressed="true"] {
    //     background: @clr-support;
    //   }
    // }
    // ```

    function toggleInfo() {
      var id = this.getAttribute("aria-controls"),
        group = document.getElementById(id),
        closed = group.getAttribute("aria-hidden") === "true";

      if (closed) $('[aria-controls="' + id + '"]').addClass("active");

      $('.p-form-group-info-link[aria-controls="' + id + '"]').toggleClass(
        "p-form-group-info-expanded"
      );

      $(group).slideToggle(function () {
        var hidden = this.getAttribute("aria-hidden") === "true";
        var id = this.getAttribute("id");
        this.setAttribute("aria-hidden", !hidden);
        $('[aria-controls="' + id + '"]')
          .attr("aria-pressed", hidden)
          .removeClass("active");
      });
    }
    $(document)
      .on("click", ".p-form-group-info-link", toggleInfo)
      .on("click", ".p-form-group-info-close", toggleInfo)
      .on("mousedown", "fieldset[disabled] .p-form-group-info-link", toggleInfo)
      .on(
        "mousedown",
        "fieldset[disabled] .p-form-group-info-close",
        toggleInfo
      );
  });
})(jQuery, document);
